// material-ui
import { useTheme, styled } from '@mui/material/styles';
import {
    Avatar,
    Button,
    Card,
    CardContent,
    Chip,
    Divider,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Stack,
    Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
// assets
import { IconBrandTelegram, IconBuildingStore, IconMailbox, IconPhoto } from '@tabler/icons';
import User1 from 'assets/images/users/user-round.svg';
import PanoramaIcon from '@mui/icons-material/Panorama';
import NumberFormat from 'react-number-format';
import { Add_CartCustomer, Add_ImagesCustomer } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const ProductList = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const cart = useSelector((state) => state.cartCustomer);
    const chipSX = {
        height: 24,
        padding: '0 6px'
    };
    const chipErrorSX = {
        ...chipSX,
        color: theme.palette.orange.dark,
        backgroundColor: theme.palette.orange.light,
        marginRight: '5px'
    };

    const chipWarningSX = {
        ...chipSX,
        color: theme.palette.warning.dark,
        backgroundColor: theme.palette.warning.light
    };

    const chipSuccessSX = {
        ...chipSX,
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.success.light,
        height: 28
    };

    return (
        <List
            sx={{
                width: '100%',
                maxWidth: 330,
                py: 0,
                borderRadius: '10px',
                [theme.breakpoints.down('md')]: {
                    maxWidth: 300
                },
                '& .MuiListItemSecondaryAction-root': {
                    top: 22
                },
                '& .MuiDivider-root': {
                    my: 0
                },
                '& .list-container': {
                    pl: 7
                }
            }}
        >
            {cart.cart &&
                cart.cart.map((params) => (
                    <>
                        <Divider />
                        <ListItemWrapper sx={{ width: '320px' }}>
                            <ListItem alignItems="center">
                                <ListItemAvatar>
                                    {cart.images.find((item) => item.productId === params.productId) ? (
                                        <Avatar
                                            src={cart.images.find((item) => item.productId === params.productId)?.images?.img}
                                            variant="rounded"
                                            sx={{
                                                color: theme.palette.primary.dark,
                                                backgroundColor: theme.palette.primary.light,
                                                border: 'none',
                                                borderColor: theme.palette.primary.main
                                            }}
                                        />
                                    ) : (
                                        <Avatar
                                            variant="rounded"
                                            sx={{
                                                color: theme.palette.primary.dark,
                                                backgroundColor: theme.palette.primary.light,
                                                border: 'none',
                                                borderColor: theme.palette.primary.main
                                            }}
                                        >
                                            <PanoramaIcon />
                                        </Avatar>
                                    )}
                                </ListItemAvatar>
                                <ListItemText primary={<Typography variant="subtitle1">{params.productName}</Typography>} />
                                <ListItemSecondaryAction>
                                    <Grid container justifyContent="flex-end">
                                        <Grid item>
                                            <Typography variant="caption" display="block" gutterBottom color="#0c4da2">
                                                {params.brands && params.brands.brandsName}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Grid container direction="column" className="list-container">
                                <Grid item xs={12} sx={{ pb: 2 }}>
                                    <Stack>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1" color="gray" noWrap>
                                                Model:
                                            </Typography>
                                            <Typography variant="button" noWrap>
                                                {params.model}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1" noWrap color="gray">
                                                Ram:
                                            </Typography>
                                            <Typography variant="button" noWrap color="#0c4da2">
                                                {params.memory}
                                            </Typography>
                                            <Stack direction="row" spacing={1}>
                                                <Typography variant="subtitle1" noWrap color="gray">
                                                    Storage:
                                                </Typography>
                                                <Typography variant="button" noWrap color="#0c4da2">
                                                    {params.storage}
                                                </Typography>
                                            </Stack>
                                        </Stack>

                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1" noWrap color="gray">
                                                Price:
                                            </Typography>
                                            <Typography variant="button" color="#f57224">
                                                <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={params.stockcontrollercustomers && params.stockcontrollercustomers.salePrice}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={true}
                                                />
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1" color="gray" noWrap>
                                                IMEI:
                                            </Typography>
                                            <Typography variant="button" noWrap>
                                                {params.stockcontrollercustomers && params.stockcontrollercustomers.imei}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container justifyContent="space-between">
                                        <Grid item>
                                            <Typography variant="button" noWrap color="#0c4da2">
                                                {params.categorys?.categoryName}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <IconButton
                                                color="error"
                                                onClick={() => {
                                                    const RemoveIMEI = cart.cart.filter(
                                                        (x) => x.stockcontrollercustomers.imei !== params.stockcontrollercustomers.imei
                                                    );
                                                    const checkAmountModel = cart.cart.filter((x) => x.productId === params.productId);
                                                    if (checkAmountModel.length <= 1) {
                                                        const RemoveImage = cart.images.filter((x) => x.productId !== params.productId);
                                                        dispatch({ type: Add_ImagesCustomer, images: RemoveImage });
                                                        localStorage.setItem('imagesCustomer', JSON.stringify({ images: RemoveImage }));
                                                    }
                                                    // console.log(RemoveIMEI);
                                                    dispatch({ type: Add_CartCustomer, cart: RemoveIMEI });
                                                    localStorage.setItem('cartCustomer', JSON.stringify({ cart: RemoveIMEI }));
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ListItemWrapper>
                    </>
                ))}
            {/* <Divider />
            <ListItemWrapper>
                <ListItem alignItems="center">
                    <ListItemAvatar>
                        <Avatar
                            sx={{
                                color: theme.palette.primary.dark,
                                backgroundColor: theme.palette.primary.light,
                                border: 'none',
                                borderColor: theme.palette.primary.main
                            }}
                        >
                            <IconMailbox stroke={1.5} size="1.3rem" />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<Typography variant="subtitle1">Check Your Mail.</Typography>} />
                    <ListItemSecondaryAction>
                        <Grid container justifyContent="flex-end">
                            <Grid item>
                                <Typography variant="caption" display="block" gutterBottom>
                                    2 min ago
                                </Typography>
                            </Grid>
                        </Grid>
                    </ListItemSecondaryAction>
                </ListItem>
                <Grid container direction="column" className="list-container">
                    <Grid item xs={12} sx={{ pb: 2 }}>
                        <Typography variant="subtitle2">All done! Now check your inbox as you&apos;re in for a sweet treat!</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item>
                                <Button variant="contained" disableElevation endIcon={<IconBrandTelegram stroke={1.5} size="1.3rem" />}>
                                    Mail
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItemWrapper> */}
        </List>
    );
};

export default ProductList;
